import React from 'react';
import correctSymbol from '../../assets/correct-symbol.png'
import noStopping from '../../assets/no-stopping.png'

export default () => {
  return (
    <div className="tab-pane fade show active" id="pills-tersertifikasi" role="tabpanel" aria-labelledby="pills-tersertifikasi-tab">
      <table className="table-bordered table table-syarat" style={{fontSize: '12px'}}>
        <tr>
          <td colspan="2" style={{fontWeight: '600'}}>Persyaratan</td>
          <td>PSrE Non Instansi</td>
          <td>PSrE Instansi</td>
          <td>PSrE Asing</td>
        </tr>
        <tr>
          <td className="text-center">1</td>
          <td>Sudah diakui sebagai PSrE TERDAFTAR oleh Menteri</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">2</td>
          <td>Sertifikat Kelaikan Sistem Elektronik</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">3</td>
          <td>Tidak Berinduk dan Tidak Menjadi Induk pada PSrE lain</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">4</td>
          <td>Salinan Hasil Audit Fasilitas dan Peralatan</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">5</td>
          <td>Memiliki 12 orang Ahli Operasional</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">6</td>
          <td>Operasional PSrE Merujuk Panduan Operasional Kominfo</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">7</td>
          <td>Memiliki BCP (Business Continuity Plan)</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">8</td>
          <td>Memiliki DRP (Disaster Recovery Plan)</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">9</td>
          <td>Modal Rp 30 Miliar</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={noStopping} alt="no-stopping" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">10</td>
          <td>Asuransi Untuk Pemilik Sertifikat</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={noStopping} alt="no-stopping" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">11</td>
          <td>Pakta Integritas dan Rekam Jejak</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={noStopping} alt="no-stopping" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">12</td>
          <td>Surat Keterangan Non Pailit</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={noStopping} alt="no-stopping" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">13</td>
          <td>Surat Permohonan (Lampiran 1 PM Kominfo 11/2018)</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">14</td>
          <td>Proposal Kelengkapan (Lampiran 2 PM Kominfo 11/2018)</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
      </table>
    </div>
  )
}